import AbstractRepository from "@/repositories/AbstractRepository";

export default class DocumentRepository extends AbstractRepository {
    protected static resource: string = "document";

    protected static defaultFields: string[] = [
        "uuid",
        "clientOriginalFileName",
        "type",
        "created_at",
    ];

    public static getSearchDocumentsUrl(): string {
        return `/invoice/documents`;
    }
}
